import { render, staticRenderFns } from "./DashboardLogistics.vue?vue&type=template&id=5f153cf1"
import script from "./DashboardLogistics.vue?vue&type=script&lang=js"
export * from "./DashboardLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports